import { components, eventHandlers } from '@/utils'

import render from './render'

export default {
  name: components['expansion-panel'],

  mixins: [ eventHandlers ],

  props: {
    outline: Boolean,
    rounded: Boolean,
    preventClick: Boolean,
    expandOnMounted: Boolean
  },

  data() {
    return {
      expanded: false
    }
  },

  computed: {
    $_class() {
      return {
        [components['expansion-panel']]: true,
        [`${components['expansion-panel']}--outline`]: this.outline,
        [`${components['expansion-panel']}--rounded`]: this.rounded
      }
    }
  },

  mounted() {
    if (this.expandOnMounted) {
      this.toggle()
    }

    this.$nextTick(() => {
      this.$emit('mounted', {
        expanded: this.expanded,
        toggle: this.toggle
      })
    })
  },

  methods: {
    toggle() {
      this.expanded = !this.expanded
      this.$emit('toggle', this.expanded)

      return this.expanded
    },

    on(event, callback) {
      return this.$on(event, callback)
    },
    off(event, callback) {
      return this.$off(event, callback)
    }
  },

  render
}
